import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';
import clsx from 'clsx';
import type { OdinIconName } from '../odin-icon/odin-icon.component';

export interface TabViewPanelProps {
  header: string | JSX.Element;
  active?: boolean;
  leftIcon?: OdinIconName;
  rightIcon?: OdinIconName;
  disabled?: boolean;
  closable?: boolean;
  panelStyles?: string;
  children: ReactNode;
  showScrollbars?: boolean;
}

export default function TabViewPanel({ active, panelStyles, children, showScrollbars = true }: TabViewPanelProps) {
  const [hasActivated, setHasActivated] = useState(false);

  useEffect(() => {
    if (active === true && !hasActivated) {
      setHasActivated(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Only activate once when active becomes true
  }, [active]);

  const tabPanelStyles = clsx('odin-grow odin-p-2 custom-scroll', panelStyles, {
    'odin-overflow-scroll': showScrollbars,
    'odin-hidden': !active,
  });

  return <>{hasActivated && <div className={tabPanelStyles}>{children}</div>}</>;
}
